(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["divarouj-cro-suite"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var config = document.getElementById('divarouj-cro-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';

    var locale = document.documentElement.lang || 'ar-EG';
    var rootUrl = config.dataset.rootUrl || '/';

    function addBusinessDays(start, days) {
      var date = new Date(start.getTime());
      var added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 5 && date.getDay() !== 6) added += 1;
      }
      return date;
    }

    function deliveryText() {
      var formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
      var now = new Date();
      var from = formatter.format(addBusinessDays(now, 2));
      var to = formatter.format(addBusinessDays(now, 5));
      return [config.dataset.deliveryPrefix, from, config.dataset.deliverySeparator, to].join(' ');
    }

    function updateDeliveryRanges(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-diva-delivery-range]'), function (element) {
        element.textContent = deliveryText();
      });
    }

    function placeContextCards() {
      var productCard = document.querySelector('[data-diva-cro-product]');
      var productForm = document.querySelector('.dvpp-panel form.dvpp-options');
      if (productCard && productForm) {
        productForm.insertAdjacentElement('afterend', productCard);
        productCard.hidden = false;
      }

      var cartCard = document.querySelector('[data-diva-cro-cart]');
      var cartCheckout = document.querySelector('.t4s-btn-group__checkout-update, [data-diva-checkout-fallback]');
      if (cartCard && cartCheckout) {
        cartCheckout.insertAdjacentElement('beforebegin', cartCard);
        cartCard.hidden = false;
      }
    }

    function enhanceAccessibility() {
      var thumbs = document.querySelectorAll('[data-dvpp-thumb]');
      Array.prototype.forEach.call(thumbs, function (button, index) {
        if (!button.getAttribute('aria-label')) {
          button.setAttribute('aria-label', (button.querySelector('img') && button.querySelector('img').alt || document.title) + ' ' + (index + 1) + '/' + thumbs.length);
        }
      });
    }

    var sizeGuideReturnFocus = null;

    function prepareSizeGuide() {
      var modal = document.querySelector('[data-dvpp-modal]');
      if (!modal) return;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      if (!modal.hasAttribute('aria-hidden')) modal.setAttribute('aria-hidden', 'true');
      var heading = modal.querySelector('h3');
      if (heading) {
        if (!heading.id) heading.id = 'divarouj-size-guide-title';
        modal.setAttribute('aria-labelledby', heading.id);
      }
    }

    function openSizeGuide(trigger) {
      var root = trigger.closest('[data-dvpp]');
      var modal = root && root.querySelector('[data-dvpp-modal]');
      if (!modal) return;
      sizeGuideReturnFocus = trigger;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var close = modal.querySelector('[data-dvpp-modal-close]');
      if (close) close.focus();
    }

    function closeSizeGuide(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (sizeGuideReturnFocus && document.contains(sizeGuideReturnFocus)) sizeGuideReturnFocus.focus();
      sizeGuideReturnFocus = null;
    }

    function enhanceDrawer() {
      var footer = document.querySelector('#divaStableCart .dcv-foot');
      if (!footer || footer.querySelector('.diva-cro-drawer-note')) return;
      var buttons = footer.querySelector('.dcv-btns');
      if (!buttons) return;
      var note = document.createElement('div');
      note.className = 'diva-cro-drawer-note';
      var strong = document.createElement('strong');
      strong.textContent = config.dataset.deliveryTitle;
      var range = document.createElement('span');
      range.setAttribute('data-diva-delivery-range', '');
      range.textContent = deliveryText();
      note.appendChild(strong);
      note.appendChild(range);
      buttons.insertAdjacentElement('beforebegin', note);
    }

    function money(value) {
      /* Shopify's product recommendations JSON returns prices in the
         currency's minor unit (piastres/cents), while Intl expects the
         major unit. Convert once here so EGP 415 is never shown as 41,500. */
      var number = Number(value || 0) / 100;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: config.dataset.currency || 'EGP' }).format(number);
      } catch (error) {
        return number.toFixed(2) + ' ' + (config.dataset.currency || 'EGP');
      }
    }

    function imageSource(product) {
      if (product.featured_image) return product.featured_image;
      if (Array.isArray(product.images) && product.images.length) {
        return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
      }
      return '';
    }

    function recommendationCard(product) {
      var variant = Array.isArray(product.variants) ? product.variants.find(function (item) { return item.available !== false; }) : null;
      var article = document.createElement('article');
      article.className = 'dvpp-pcard diva-cro-rec-card';

      var mediaLink = document.createElement('a');
      mediaLink.className = 'dvpp-pc-img-wrap';
      mediaLink.href = product.url;
      var src = imageSource(product);
      if (src) {
        var image = document.createElement('img');
        image.className = 'dvpp-pc-img';
        image.src = src;
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.sizes = '(max-width: 749px) 50vw, 260px';
        mediaLink.appendChild(image);
      }
      article.appendChild(mediaLink);

      var body = document.createElement('div');
      body.className = 'dvpp-pc-body';
      var title = document.createElement('a');
      title.className = 'dvpp-pc-title';
      title.href = product.url;
      title.textContent = product.title || '';
      body.appendChild(title);

      var price = document.createElement('div');
      price.className = 'dvpp-pc-pricing';
      var current = document.createElement('b');
      current.className = 'dvpp-pc-price';
      current.textContent = money(variant ? variant.price : product.price);
      price.appendChild(current);
      body.appendChild(price);

      if (variant && product.variants.length === 1) {
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'diva-cro-rec-action';
        add.dataset.divaCroAdd = variant.id;
        add.textContent = config.dataset.addLabel;
        body.appendChild(add);
      } else {
        var select = document.createElement('a');
        select.className = 'diva-cro-rec-action';
        select.href = product.url;
        select.textContent = config.dataset.selectLabel;
        body.appendChild(select);
      }

      article.appendChild(body);
      return article;
    }

    async function fetchRecommendationIntent(productId, intent) {
      var url = rootUrl + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=8&intent=' + encodeURIComponent(intent);
      var response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return [];
      var data = await response.json();
      return Array.isArray(data.products) ? data.products : [];
    }

    async function enhanceRecommendations() {
      var productId = config.dataset.productId;
      var grid = document.querySelector('.dvpp-pgrid--related');
      if (!productId || !grid || grid.dataset.divaRecommendations === 'true') return;
      grid.dataset.divaRecommendations = 'true';

      try {
        var sets = await Promise.all([
          fetchRecommendationIntent(productId, 'complementary'),
          fetchRecommendationIntent(productId, 'related')
        ]);
        var seen = {};
        var products = [];
        sets[0].concat(sets[1]).forEach(function (item) {
          if (!item || seen[item.id] || item.available === false) return;
          seen[item.id] = true;
          products.push(item);
        });
        if (!products.length) return;

        grid.replaceChildren();
        products.slice(0, 6).forEach(function (item) { grid.appendChild(recommendationCard(item)); });
        var heading = grid.closest('.dvpp-section') && grid.closest('.dvpp-section').querySelector('.dvpp-sh h2');
        if (heading) heading.textContent = config.dataset.recommendationsTitle;
        var seeAll = grid.closest('.dvpp-section') && grid.closest('.dvpp-section').querySelector('.dvpp-sh-link');
        if (seeAll) seeAll.hidden = true;
      } catch (error) {
        grid.dataset.divaRecommendations = 'fallback';
      }
    }

    async function addRecommendedItem(button) {
      var variantId = button.dataset.divaCroAdd;
      if (!variantId || button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        var response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('add');
        var cartResponse = await fetch(rootUrl + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        var cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { detail: cart, bubbles: true }));
      } catch (error) {
        window.location.href = button.closest('.diva-cro-rec-card').querySelector('a').href;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }

    document.addEventListener('click', function (event) {
      var sizeGuide = event.target.closest('[data-dvpp-sizeguide]');
      if (sizeGuide) {
        event.preventDefault();
        openSizeGuide(sizeGuide);
        return;
      }

      var sizeGuideClose = event.target.closest('[data-dvpp-modal-close]');
      if (sizeGuideClose) {
        event.preventDefault();
        closeSizeGuide(sizeGuideClose.closest('[data-dvpp-modal]'));
        return;
      }

      if (event.target.matches('[data-dvpp-modal]')) {
        closeSizeGuide(event.target);
        return;
      }

      var add = event.target.closest('[data-diva-cro-add]');
      if (add) {
        event.preventDefault();
        addRecommendedItem(add);
      }
    });

    function boot() {
      if (config.dataset.pageType === 'cart' && Number(config.dataset.cartCount || 0) === 0) {
        document.body.classList.add('diva-cart-is-empty');
      }
      updateDeliveryRanges(document);
      placeContextCards();
      enhanceAccessibility();
      prepareSizeGuide();
      enhanceDrawer();
      enhanceRecommendations();
      new MutationObserver(enhanceDrawer).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var modal = document.querySelector('[data-dvpp-modal].is-open');
      if (modal) closeSizeGuide(modal);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
